import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const HomePageEn = lazy(() => import('../pages/home/page-en'));
const BeginnerPage = lazy(() => import('../pages/beginner/page'));
const KnowledgePage = lazy(() => import('../pages/knowledge/page'));
const FilamentPage = lazy(() => import('../pages/filament/page'));
const FilamentComparePage = lazy(() => import('../pages/filament/compare/page'));
const PLAPage = lazy(() => import('../pages/filament/pla/page'));
const PLAPlusPage = lazy(() => import('../pages/filament/pla-plus/page'));
const PLACFPage = lazy(() => import('../pages/filament/pla-cf/page'));
const PLASilkPage = lazy(() => import('../pages/filament/pla-silk/page'));
const MattePLAPage = lazy(() => import('../pages/filament/matte-pla/page'));
const PLAProPage = lazy(() => import('../pages/filament/pla-pro/page'));
const HTPLAPage = lazy(() => import('../pages/filament/ht-pla/page'));
const PETGPage = lazy(() => import('../pages/filament/petg/page'));
const PETGCFPage = lazy(() => import('../pages/filament/petg-cf/page'));
const PETGGFPage = lazy(() => import('../pages/filament/petg-gf/page'));
const ABSPage = lazy(() => import('../pages/filament/abs/page'));
const ABSCFPage = lazy(() => import('../pages/filament/abs-cf/page'));
const ABSGFPage = lazy(() => import('../pages/filament/abs-gf/page'));
const ASAPage = lazy(() => import('../pages/filament/asa/page'));
const ASACFPage = lazy(() => import('../pages/filament/asa-cf/page'));
const ASAGFPage = lazy(() => import('../pages/filament/asa-gf/page'));
const PCPage = lazy(() => import('../pages/filament/pc/page'));
const PCCFPage = lazy(() => import('../pages/filament/pc-cf/page'));
const PCGFPage = lazy(() => import('../pages/filament/pc-gf/page'));
const PAPage = lazy(() => import('../pages/filament/pa/page'));
const PACFPage = lazy(() => import('../pages/filament/pa-cf/page'));
const PAGFPage = lazy(() => import('../pages/filament/pa-gf/page'));
const TPUPage = lazy(() => import('../pages/filament/tpu/page'));
const BendStrengthTestPage = lazy(() => import('../pages/filament/bend-strength-test/page'));
const TroubleshootingPage = lazy(() => import('../pages/troubleshooting/page'));
const WarpingPage = lazy(() => import('../pages/troubleshooting/warping/page'));
const StringingPage = lazy(() => import('../pages/troubleshooting/stringing/page'));
const DelaminationPage = lazy(() => import('../pages/troubleshooting/delamination/page'));
const BleedingPage = lazy(() => import('../pages/troubleshooting/bleeding/page'));
const AccuracyPage = lazy(() => import('../pages/troubleshooting/accuracy/page'));
const SupportPage = lazy(() => import('../pages/troubleshooting/support/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const DisclaimerPage = lazy(() => import('../pages/disclaimer/page'));
const DataPolicyPage = lazy(() => import('../pages/data-policy/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const FilamentDataDownloadPage = lazy(() => import('../pages/filament/data-download/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/en',
    element: <HomePageEn />
  },
  {
    path: '/en/filament',
    element: <FilamentPage />
  },
  {
    path: '/en/filament/compare',
    element: <FilamentComparePage />
  },
  {
    path: '/beginner',
    element: <BeginnerPage />
  },
  {
    path: '/en/beginner',
    element: <BeginnerPage />
  },
  {
    path: '/knowledge',
    element: <KnowledgePage />
  },
  {
    path: '/en/knowledge',
    element: <KnowledgePage />
  },
  {
    path: '/filament',
    element: <FilamentPage />
  },
  {
    path: '/filament/compare',
    element: <FilamentComparePage />
  },
  {
    path: '/filament/pla',
    element: <PLAPage />
  },
  {
    path: '/en/filament/pla',
    element: <PLAPage />
  },
  {
    path: '/filament/pla-plus',
    element: <PLAPlusPage />
  },
  {
    path: '/en/filament/pla-plus',
    element: <PLAPlusPage />
  },
  {
    path: '/filament/pla-cf',
    element: <PLACFPage />
  },
  {
    path: '/en/filament/pla-cf',
    element: <PLACFPage />
  },
  {
    path: '/filament/pla-silk',
    element: <PLASilkPage />
  },
  {
    path: '/en/filament/pla-silk',
    element: <PLASilkPage />
  },
  {
    path: '/filament/matte-pla',
    element: <MattePLAPage />
  },
  {
    path: '/en/filament/matte-pla',
    element: <MattePLAPage />
  },
  {
    path: '/filament/pla-pro',
    element: <PLAProPage />
  },
  {
    path: '/en/filament/pla-pro',
    element: <PLAProPage />
  },
  {
    path: '/filament/ht-pla',
    element: <HTPLAPage />
  },
  {
    path: '/en/filament/ht-pla',
    element: <HTPLAPage />
  },
  {
    path: '/filament/petg',
    element: <PETGPage />
  },
  {
    path: '/en/filament/petg',
    element: <PETGPage />
  },
  {
    path: '/filament/petg-cf',
    element: <PETGCFPage />
  },
  {
    path: '/en/filament/petg-cf',
    element: <PETGCFPage />
  },
  {
    path: '/filament/petg-gf',
    element: <PETGGFPage />
  },
  {
    path: '/en/filament/petg-gf',
    element: <PETGGFPage />
  },
  {
    path: '/filament/abs',
    element: <ABSPage />
  },
  {
    path: '/en/filament/abs',
    element: <ABSPage />
  },
  {
    path: '/filament/abs-cf',
    element: <ABSCFPage />
  },
  {
    path: '/en/filament/abs-cf',
    element: <ABSCFPage />
  },
  {
    path: '/filament/abs-gf',
    element: <ABSGFPage />
  },
  {
    path: '/en/filament/abs-gf',
    element: <ABSGFPage />
  },
  {
    path: '/filament/asa',
    element: <ASAPage />
  },
  {
    path: '/en/filament/asa',
    element: <ASAPage />
  },
  {
    path: '/filament/asa-cf',
    element: <ASACFPage />
  },
  {
    path: '/en/filament/asa-cf',
    element: <ASACFPage />
  },
  {
    path: '/filament/asa-gf',
    element: <ASAGFPage />
  },
  {
    path: '/en/filament/asa-gf',
    element: <ASAGFPage />
  },
  {
    path: '/filament/pc',
    element: <PCPage />
  },
  {
    path: '/en/filament/pc',
    element: <PCPage />
  },
  {
    path: '/filament/pc-cf',
    element: <PCCFPage />
  },
  {
    path: '/en/filament/pc-cf',
    element: <PCCFPage />
  },
  {
    path: '/filament/pc-gf',
    element: <PCGFPage />
  },
  {
    path: '/en/filament/pc-gf',
    element: <PCGFPage />
  },
  {
    path: '/filament/pa',
    element: <PAPage />
  },
  {
    path: '/en/filament/pa',
    element: <PAPage />
  },
  {
    path: '/filament/pa-cf',
    element: <PACFPage />
  },
  {
    path: '/en/filament/pa-cf',
    element: <PACFPage />
  },
  {
    path: '/filament/pa-gf',
    element: <PAGFPage />
  },
  {
    path: '/en/filament/pa-gf',
    element: <PAGFPage />
  },
  {
    path: '/filament/tpu',
    element: <TPUPage />
  },
  {
    path: '/en/filament/tpu',
    element: <TPUPage />
  },
  {
    path: '/filament/bend-strength-test',
    element: <BendStrengthTestPage />
  },
  {
    path: '/en/filament/bend-strength-test',
    element: <BendStrengthTestPage />
  },
  {
    path: '/filament/data-download',
    element: <FilamentDataDownloadPage />
  },
  {
    path: '/en/filament/data-download',
    element: <FilamentDataDownloadPage />
  },
  {
    path: '/troubleshooting',
    element: <TroubleshootingPage />
  },
  {
    path: '/en/troubleshooting',
    element: <TroubleshootingPage />
  },
  {
    path: '/troubleshooting/warping',
    element: <WarpingPage />
  },
  {
    path: '/en/troubleshooting/warping',
    element: <WarpingPage />
  },
  {
    path: '/troubleshooting/stringing',
    element: <StringingPage />
  },
  {
    path: '/en/troubleshooting/stringing',
    element: <StringingPage />
  },
  {
    path: '/troubleshooting/delamination',
    element: <DelaminationPage />
  },
  {
    path: '/en/troubleshooting/delamination',
    element: <DelaminationPage />
  },
  {
    path: '/troubleshooting/bleeding',
    element: <BleedingPage />
  },
  {
    path: '/en/troubleshooting/bleeding',
    element: <BleedingPage />
  },
  {
    path: '/troubleshooting/accuracy',
    element: <AccuracyPage />
  },
  {
    path: '/en/troubleshooting/accuracy',
    element: <AccuracyPage />
  },
  {
    path: '/troubleshooting/support',
    element: <SupportPage />
  },
  {
    path: '/en/troubleshooting/support',
    element: <SupportPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/en/privacy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />
  },
  {
    path: '/en/disclaimer',
    element: <DisclaimerPage />
  },
  {
    path: '/data-policy',
    element: <DataPolicyPage />
  },
  {
    path: '/en/data-policy',
    element: <DataPolicyPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/en/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
